import { HttpResponse } from "@angular/common/http";
import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { CalendarOptions } from "@fullcalendar/angular";
import { Subscription } from "rxjs";
import { Constants } from "src/app/app.constants";
import { AppService } from "src/app/app.service";
import { StorageService } from "src/app/app.storage.service";
import { CommonService } from "src/app/common.service";
import { AttendanceConstant } from "../attendance.constant";
import { AttendanceService } from "../attendance.service";

declare var moment: any;
@Component({
    selector: 'app-team-attendance',
    templateUrl: './team-attendance.component.html',
    styleUrls: ['./team-attendance.component.css']
})

export class TeamAttendnaceComponent{
    constructor(
      private attendanceService: AttendanceService,
      private router: Router,
      private storageService: StorageService,
      private commonService: CommonService,
      private appService : AppService
    ){

    }

    private _myVar: any = moment();
    daysListOfMonth: any [] = [];
    isLoader: boolean = false;
    teamAttendanceList: any[] = [];
    attendanceTypeMap: any = {};
    attendanceStatusMap: any = AttendanceConstant.ATTENDANCE_STATUS_MAP;
    statusList :any[]= AttendanceConstant.ATTENDANCE_STATUS_LIST;
    isAllCheck: boolean = false;
    attendanceTypeSubscription: Subscription;
    markAttendanceSubscription: Subscription;
    approveStatusObj: any = null;
    selectedTimestamp: number = null;
    fieldUserSearch : any;
    filteredData: { count: number, filteredList: any[] } = { count: 0, filteredList: [] };
    searchableHeaderKeys: any[] = ["name"]
    userList : any [] =[];
    teamAttendanceListAll : any [] = [];
    imageUrl: string = Constants.IMAGE_BASE_URL;
    
    ngOnInit(){
      // this.attendanceTypeSubscription = this.attendanceService.attendanceTypeSubject.subscribe((data)=>{
      //   if(data){
      //       this.attendanceTypeMap = data.map;
      //   }
      // })

      this.markAttendanceSubscription = this.attendanceService.markAttendanceSubject.subscribe((data)=>{
            
        if(data){
          if(this.selectedTimestamp){
            this.getTeamAttendance(this.selectedTimestamp);
          } 
        }
      })
      this.statusList = this.statusList.filter(obj => obj.flag ==true);
      console.log(this.statusList)
      
    }

    ngOnDestroy(){
      if(this.attendanceTypeSubscription){
        this.attendanceTypeSubscription.unsubscribe()
      }
      if(this.markAttendanceSubscription){
        this.markAttendanceSubscription.unsubscribe();
      }
    }

    get myVar(): string {
        return this._myVar;
    }
    set myVar(value: string) {
        if (value !== this._myVar) {
            this._myVar = value;
            let strArr = this._myVar.split("-");
            let date = new Date(parseInt(strArr[0]), parseInt(strArr[1])-1);
            let time = date.getTime()/1000 |0;
            this.selectedTimestamp = time;
            this.getTeamAttendance(time);
        }
    }

    getDaysOfMonth(timestamp?){
      let month = moment();
      if(timestamp){
        month = moment(timestamp * 1000);
      }
      let days = Array.from({length: month.daysInMonth()}, (x, i) =>{
        return month.startOf('month').add(i, 'days').format('dd');
      });
      return days;
    }

    async getTeamAttendance(timestamp?){

      if (Object.keys(this.attendanceTypeMap).length <= 0) {
        let data = await this.appService.getAttendnaceTypeObject().catch(() => { });
        if (data) {
          this.attendanceTypeMap = data.map;
        }
      }

      let colorArray = Constants.RANDOM_COLOR_CLASS;
      this.isLoader = true;
      this.daysListOfMonth = this.getDaysOfMonth(timestamp);
      // console.log(this.daysListOfMonth);
      this.attendanceService.getTeamAttendance(timestamp)
        .subscribe((res: HttpResponse<any>) =>{
          this.isLoader = false;
          // console.log(res.body)
          this.teamAttendanceList = res.body.attendances;
          for(let obj of this.teamAttendanceList){

              let dayWiseattendenceMap = obj.dayWiseAttendances;
              let daywiseAttenValuesList: any =Object.values(dayWiseattendenceMap);
              if(daywiseAttenValuesList && daywiseAttenValuesList.length){
                for(let dayWiseObject of daywiseAttenValuesList){
                  if(dayWiseObject.mark){
                    obj["checkBoxFlagBasedOnMark"] = true;
                    break;
                  }
                }
              }
              
            obj.userInfo['asigneeRandomColorClass'] = colorArray[Math.floor(Math.random() * colorArray.length)];
            obj.userInfo['shortName'] = obj.userInfo.name ? this.commonService.nameSorting(obj.userInfo.name) : "";
            this.userList.push(obj.userInfo)
          }
          // console.log(this.teamAttendanceList)
          this.teamAttendanceListAll = this.teamAttendanceList
        }, (err)=>{
          this.isLoader = false;
        })
    }

    getAttendnaceMark(mark){
      if(mark){
        let markStr = this.attendanceTypeMap && this.attendanceTypeMap[mark] ? this.attendanceTypeMap[mark].name : "";
        if(markStr){
          return this.commonService.nameSorting(markStr);
          return markStr.substring(0, 1);
        }
      }
      return "";
    }

    getAttendanceSttusColor(emp, i){
      if(emp.dayWiseAttendances && emp.dayWiseAttendances[i+1]){
        let attendance = emp.dayWiseAttendances[i+1];
        if( attendance && attendance.status && this.attendanceStatusMap[attendance.status]){
          return this.attendanceStatusMap[attendance.status].statusClas;
        }
      }
      return "";
    }


    navigateToEditAttendnace(emp){
      // this.attendanceService.showLeaveApplicationSubject.next(false);
      this.storageService.setDataInLocalStorage(Constants.STORAGE_KEY.EDIT_ATTENDANCE_PERSON, emp)
      this.router.navigate(['home/attendance/edit-team-attendance']);
    }

    checkAllClick(){
      let bool = false;
      if(this.isAllCheck){
          bool = true;
      }
      for(let obj of this.teamAttendanceList){
          obj.isChecked = bool;
      }
    }

    checkedemployeeFlag = false;
    saveAttendnaceApproval(){
      let attendanceApproveList = [];
      this.checkedemployeeFlag = false
      // for(let emp of this.teamAttendanceList){
      //   if(emp.isChecked){
      //     this.checkedemployeeFlag = true;
      //     break;
      //   }else{
      //     continue;
      //   }
      // }
      for(let emp of this.teamAttendanceList){
        let attendnaceMap = emp.dayWiseAttendances;
        let values: any = Object.values(attendnaceMap);
        if(emp.isChecked){
          this.checkedemployeeFlag = true;
          if(values && values.length>0){
            for(let obj of values){
            if(obj.mark && obj.status == 1){
              // if(emp.isChecked && obj.mark && obj.status ){
                let object = {};
                object['id'] = obj.id;
                // object['status'] = obj.status;
                object['status'] = this.approveStatusObj.key;
                attendanceApproveList.push(object);
              }
            }
          }
      }
      }
      if (attendanceApproveList && attendanceApproveList.length > 0) {
            this.attendanceService.saveAttendnaceApproval(attendanceApproveList)
              .subscribe((res: HttpResponse<any>) => {
                // console.log(res.body);
                this.appService.showSuccessPopup("Success", res.body.message);
                this.getTeamAttendance();
                this.approveStatusObj = null ;
              }, (err) => {
                this.appService.showErrorPopup("Error", "Something went wrong.");
              })
      }else if(this.checkedemployeeFlag){
        this.approveStatusObj = null ;
        this.appService.showErrorPopup("Message", "No any pending attendance for the selected users.");
        return;
      }else{
        this.approveStatusObj = null ;
        this.appService.showErrorPopup("Message", "Please Check atleast one Attendance!");
        return;
      }
    }

    changeApprovalStatus(approveStatusObj){
    
      var message = "Are you sure you want to change the status?";
      var title = "Message"
      this.appService.showConfirmationPopup(title, message).then((result) => {
        if (result.value) {
          this.saveAttendnaceApproval();
        }else{
          this.approveStatusObj = null ;
        }
      })
      
    }
  
    onSelectedUserChange(userObject) {
      
      this.teamAttendanceList = [];
      var index = null;
      if (userObject.checked) {
        userObject.checked = true;
      } else {
        userObject.checked = false;
      }
      if (this.userList && this.userList.length > 0) {
          var userIds = [];
          // for(let u of this.userList){
          //     if(u.checked){
          //         userIds.push(u.id);
          //     }

          // }
          for (index in this.userList) {
              if (this.userList[index].checked) {
                  userIds.push(this.userList[index].id);
              }
             
          }

          for (let team of this.teamAttendanceListAll) {
              if (userIds.includes(team.userInfo.id)) {
                  this.teamAttendanceList.push(team);
              }
          }
          if (userIds.length == 0) {
              this.teamAttendanceList = this.teamAttendanceListAll;
          }
      } else {
          this.teamAttendanceList = this.teamAttendanceListAll;
      }
  }


}